import { useEffect, useState } from 'react';
import { mailError } from '../mailboxModel';
import { signatureDraftFields } from '../signatureModel';
import { fetchSignature } from '../models/mailApi';

export function useComposerSignature({ draft, profile, setDraft }) {
  const [signatureError, setSignatureError] = useState('');
  const [signatureRetry, setSignatureRetry] = useState(0);
  const gmailDraft = draft.mode === 'gmail-draft';
  const needsSignature = !gmailDraft && !draft.signature_initialized && !draft.command;
  useEffect(() => {
    if (!needsSignature) return undefined;
    let active = true;
    setSignatureError('');
    fetchSignature().then(data => {
      if (active) setDraft(current => current ? { ...current, ...signatureDraftFields(current, data.signature, profile.primary_email) } : current);
    }).catch(failure => { if (active) setSignatureError(mailError(failure)); });
    return () => { active = false; };
  }, [needsSignature, profile.primary_email, setDraft, signatureRetry]);
  return { needsSignature, signatureError, retrySignature: () => setSignatureRetry(value => value + 1) };
}
